import React from "react";
import "@frameworks/shared-library/stylesheets/components/GenericTooltipInnerContent.scss";
var GenericTooltipInnerContent = function (_a) {
    var tooltipTitle = _a.tooltipTitle, _b = _a.tooltipCustom, tooltipCustom = _b === void 0 ? [] : _b, _c = _a.hideCross, hideCross = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: "primary__generic__tooltip__inner__content d-flex flex-column justify-content-center" },
        React.createElement("div", { className: "infoWrapper d-flex align-items-center" },
            React.createElement("p", { className: "infoText mb-0 flex-grow-1" },
                React.createElement("div", { className: "DMsanR_12_300" }, tooltipTitle),
                tooltipCustom.map(function (type, index) { return (React.createElement("div", { key: type.name, className: "mgt-20" },
                    React.createElement("span", { className: "DMSansMedium_12_500" },
                        type.name,
                        ": "),
                    React.createElement("span", { className: "DMsanR_12_300" }, type.description))); })),
            !hideCross && (React.createElement("i", { className: "edel-icon-close align-self-start mgt-2 txt_medium-gray cursor-pointer" })))));
};
export default GenericTooltipInnerContent;
